import { Loading } from "element-ui";

export default {
  selected_documents : [],
  baseDocuments: [],
  branchoffices: [],
  warehouses: [],
  status: [],
  model: {
    operation_type: {
      code: null
    },
    voucher_type: {
      code_voucher_type: null
    }
  },
  params: {
    paginate: false,
    page: 1,
    perPage: 15,
    filter: "",
    filterDate: [],
    sortBy: "voucher_date",
    sort: "DESC",
    closed: false,
    retained: false,
    rejected: false,
    seller_id: [],
    user_id:null,
    city_id:null,
    state_auth: ["03", "05"],
    state_backorder: ["1", "2"],
    product:[],
    detailed_by_product:1,
    contact:null,
    document: ""
  },
  loadingBaseDocuments: false,
  error: false,
  errorMessage: "",
  documentsByAuthorize: [],
  loadingAuthorizedDocuments: false,
  selected_rows: [],
  products:[],
  disabled_select:false,
  cities:[],
  users:[],
  params_:{
    date:null
  },
  contacts:[],
  documents_products:[],
  selected_documents_products:[],
  loading_base:{
    selected_documents:false
  },
  pagination: {
    total_rows: null,
    per_page: null
  }
};



// WEBPACK FOOTER //
// ./src/modules/base-documents/state.js